import { Divider, StackView, Text, Button } from '@planningcenter/tapestry-react';
import React from 'react';
import { getPrimaryButtonStyleOverrides } from '../../utils/index.js';

const NewChatViewFooter = ({ text, buttonDisabled, showSpinner, onButtonClick, }) => (React.createElement(React.Fragment, null,
    React.createElement(Divider, null),
    React.createElement(StackView, { grow: 0, marginHorizontal: "auto", padding: 2, spacing: 2 },
        React.createElement(Text, { align: "center", size: 5, color: "foregroundSecondary" }, text),
        React.createElement(Button, { "aria-label": "Start conversation", disabled: buttonDisabled, onClick: onButtonClick, ...getPrimaryButtonStyleOverrides({
                disabled: buttonDisabled,
                spinner: showSpinner,
            }) }, "Start conversation"))));

export { NewChatViewFooter };
//# sourceMappingURL=footer.js.map
